import { createFileRoute } from '@tanstack/react-router'
import { BriefingsSection } from '~/components/marketing/briefings-section'
import { CrmSection } from '~/components/marketing/crm-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { ProposalsSection } from '~/components/marketing/proposals-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Client pipeline — CRM, briefs and proposals | Planno'
const PAGE_DESCRIPTION =
  'A lead pipeline, configurable intake briefs, and proposals on a public link. The whole front end of an architecture practice, in one place.'

export const Route = createFileRoute('/en/features/client-pipeline')({
  component: ClientPipelinePage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'en',
      path: '/en/features/client-pipeline',
      title: PAGE_TITLE,
    }),
})

function ClientPipelinePage() {
  return (
    <MarketingShell locale="en">
      <CrmSection headingLevel="h1" />
      <BriefingsSection />
      <ProposalsSection />
    </MarketingShell>
  )
}
